import { render, staticRenderFns } from "./MemberDetails.vue?vue&type=template&id=527ab7b4&scoped=true&"
import script from "./MemberDetails.vue?vue&type=script&lang=js&"
export * from "./MemberDetails.vue?vue&type=script&lang=js&"
import style0 from "./MemberDetails.vue?vue&type=style&index=0&id=527ab7b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527ab7b4",
  null
  
)

export default component.exports